(function () {
  // close menu after navigation
  const menu_toggle = document.getElementById('wra-menu-toggle');
  const nav_items = document.getElementsByClassName('wra-header__navbar-item');

  for (let i = 0; i < nav_items.length; i++) {
    nav_items.item(i).addEventListener('click', () => menu_toggle.checked = false);
  }
}());
